import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "stock/packagings";

export const GET_STOCK_PACKAGINGS = "getStockPackagings";
export const GET_STOCK_PACKAGING = "getStockPackaging";
export const CREATE_STOCK_PACKAGING = "createStockPackaging";
export const UPDATE_STOCK_PACKAGING = "updateStockPackaging";
export const DELETE_STOCK_PACKAGING = "deleteStockPackaging";

const actions = {
  [GET_STOCK_PACKAGINGS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_PACKAGING](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_PACKAGING](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_PACKAGING](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_PACKAGING](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data ?? error));
    });
  },
};

export default {
  actions,
};
